<div class="MessageModal">
    <mat-toolbar>
        <h3>{{ "errormessage.warning" | translate }}</h3>
    </mat-toolbar>
        <mat-dialog-content><br/>
            <span  class="mt-25"></span><br/>
            <span>{{ "role.existing.user.message2" | translate : { NUMBER_OF_USERS: counts_users } }}</span><br/>
            <form class="form-signin p-15 flex flex-wrap justify-between" [formGroup]="form">
                <div class="w-[98%] md:w-full">
                    <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ "locations" | translate }}</mat-label>
                    <mat-select required class="form-control" formControlName="usrLocations" multiple>
                        <mat-option [value]="location.locID" *ngFor="let location of location_list$">
                        {{location.locName}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="form.controls['usrLocations'].invalid">
                    <mat-error *ngIf="form.controls['usrLocations'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                    </ng-container>
                </div>
                <div class="w-[98%] md:w-full submit_button">
                    <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="isValid(form)"
                      mat-dialog-close>
                      {{ "confirm" | translate }}
                    </button>
                  </div>
            </form>
        </mat-dialog-content>
        
        <mat-dialog-actions style="float:right">
            <button mat-dialog-close mat-button mat-raised-button color="accent">{{ "close" | translate }}</button>
        </mat-dialog-actions>
  </div>